module.exports = __webpack_public_path__ + "img/bt-1-on.2fadeaf4.png";